import { render } from "./ShareFacebook.vue?vue&type=template&id=0c48a993"
import script from "./ShareFacebook.vue?vue&type=script&lang=js"
export * from "./ShareFacebook.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__